export default __webpack_public_path__ + "static/media/warning.9bbdb2f3.svg";